// extracted by mini-css-extract-plugin
export var bubble = "_17-0";
export var container = "_17-3";
export var contrastBorder = "_17-4";
export var greyOut = "_17-2";
export var initialsWrapper = "_17-1";
export var large = "_17-9";
export var medium = "_17-8";
export var mediumSmall = "_17-7";
export var mediumSmallMedium = "_17-c";
export var micro = "_17-5";
export var small = "_17-6";
export var tiny = "_17-b";
export var xTiny = "_17-a";